<template>
    <div v-if="loaded">
        <card-header icon="fa-file-certificate" :title="application.applications.title" />

        <card-body>
            <card-list>
                <subheader-list-item title="Specifics" icon="fa-file-certificate" />
            </card-list>

            <data-row :title="application.applications.certification_certs.certifications.unit_title">{{ application.max_units }}</data-row>
            <data-row title="Minimum Time" v-if="application.min_minutes_required">{{ application.min_minutes_required }} minutes</data-row>

            <card-list>
                <subheader-list-item title="Course" icon="fa-file-certificate" />
            </card-list>

            <data-row title="Course">{{ application.courses.title }}</data-row>
            <data-row title="Provider" v-if="application.courses.content_providers">{{ application.courses.content_providers.title }}</data-row>

            <data-row title="Conference Code">
                <b-tag type="is-primary"><i class="far fa-tag ml-1 mr-1"></i> {{ application.courses.code }}</b-tag>
            </data-row>

            <card-list>
                <subheader-list-item title="Application" icon="fa-file-certificate" />
            </card-list>

            <data-row title="Application">{{ application.applications.title }}</data-row>
            <data-row title="Approvals Required">{{ application.applications.min_approvals }}</data-row>
            <data-row title="Certification">{{ application.applications.certification_certs.certifications.title }}</data-row>

            <card-list>
                <subheader-list-item title="Compliance" icon="fa-file-certificate" />
            </card-list>

            <data-row title="Syllabus">{{ application.syllabus }}</data-row>
            <data-row title="Goals">{{ application.goals }}</data-row>
            <data-row title="Objectives">{{ application.objectives }}</data-row>
            <data-row title="Outcomes">{{ application.outcomes }}</data-row>
            <data-row title="Standards">{{ application.standards }}</data-row>
            <data-row title="Instructor">{{ application.instructor }}</data-row>
            <data-row title="Resume">{{ application.resume }}</data-row>
            <data-row title="Expected Participants">{{ application.num_participants }}</data-row>


            <card-list>
                <subheader-list-item title="Approval History" icon="fa-clock-rotate-left" />

                <card-list-item v-for="app in application.course_application_approvals">
                    <template v-slot:icon><i class="far fa-user fa-fw"></i></template>
                    <template v-slot:content>
                        <div class="tile-title">{{ app.portal_users.first_name }} {{ app.portal_users.last_name }}</div>
                        <div class="meta">Approved on {{ app.created_at | moment('MMMM Do') }}</div>
                    </template>
                </card-list-item>
            </card-list>


        </card-body>

        <card-footer>
            <div class="columns">
                <div class="column">
                    <!--                    <b-button type="is-danger" size="is-small" class="m-2" @click="reject()" disabled>-->
                    <!--                        <b-icon icon="times" class="mr-2"></b-icon>-->
                    <!--                        Reject-->
                    <!--                    </b-button>-->
                </div>
                <div class="column">
                    <div class="is-pulled-right">
                        <b-button type="is-success" size="is-small" class="m-2" @click="approve()" :disabled="approveDisabled">
                            <b-icon icon="check" class="mr-2"></b-icon>
                            Approve
                        </b-button>
                    </div>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import RenderComponent from "@/components/RenderComponent";

    import {client as http} from "@/http_client";
    import CardFooter from "../../TIER/components/CardFooter";
    import CardList from "../../TIER/components/CardList";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import ContainerListItem from "../../TIER/components/ContainerListItem";
    import DataRow from "../../TIER/components/DataRow";
    import moment from "moment";
    import SeparatorListItem from "../../TIER/components/SeparatorListItem";
    import CardListItem from "../../TIER/components/CardListItem";
    import async from "async";
    import ApplicationView from "../applications/applicants/ApplicationView.vue";
    import {mapGetters} from 'vuex';

    export default {
        components: {ApplicationView, CardListItem, SeparatorListItem, DataRow, ContainerListItem, SubheaderListItem, CardList, CardFooter, RenderComponent, CardBody, CardHeader},
        props: ['card', 'props'],
        data: function () {
            return {
                application: null,
                loaded: false,
            };
        },
        computed: {
            ...mapGetters(['currentUser']),

            approveDisabled: function () {
                for (let i = 0; i < this.application.course_application_approvals.length; i++) {
                    if (this.application.course_application_approvals[i].portal_users.id === this.currentUser.id) {
                        return true;
                    }
                }
            }
        },
        methods: {
            load: function () {
                this.$emit('loading', true);
                http.get('/courses/' + this.props.courseId + '/applications/' + this.props.courseAppId, {force: true}).then(response => {
                    this.application = response.data;
                    this.$emit('loading', false);
                    this.loaded = true;
                }).catch(err => {
                    console.log(err);
                });
            },
            approve() {
                this.$emit('loading', true);
                http.post('/courses/' + this.props.courseId + '/applications/approve', {id: this.props.courseAppId}).then(response => {
                    this.$closeCard(this.card);
                    this.$reloadCard('reviews');
                }, err => {
                    console.log(err);
                });
            },
            reject() {
                // this.$emit('loading', true);
                // http.post('/applications/reject/', {id: this.props.reviewId}).then(response => {
                //     this.$closeCard(this.card);
                //     this.$reloadCard('reviews');
                // }, err => {
                //     console.log(err);
                // });
            }
        },
        watch: {
            'props.courseAppId': function () {
                this.load();
            }
        },
        mounted: function () {
            this.load();
        }
    };
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .component-content {
        margin: 2rem 0;
    }
</style>
